import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => {
  const year = new Date().getFullYear();

  return (
    <div className="abs-center wd-xl">
      <div className="text-center mb-4">
        <div className="text-lg mb-3">404</div>
        <p className="lead m-0">We couldn't find this page.</p>
        <p>The page you are looking for does not exists.</p>
      </div>
      <ul className="list-inline text-center text-sm mb-4">
        <li className="text-muted list-inline-item">|</li>
        <li className="list-inline-item">
          <Link to="login" className="text-muted">
            Login
          </Link>
        </li>
        <li className="text-muted list-inline-item">|</li>
        <li className="list-inline-item">
          <Link to="register" className="text-muted">
            Register
          </Link>
        </li>
      </ul>
      <div className="p-3 text-center">
        <span className="mr-2">&copy;</span>
        <span>{year}</span>
        <span className="mx-2">-</span>
        <span>Vourity</span>
      </div>
    </div>
  );
};
